// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1r0b2","label":"CategoryService_label__3ZyK9","location":"CategoryService_location__3tA0C"};